import React from "react";
import svg1 from "./images/svg2.svg";

export default function LogoWidget() {
  return (
    <div className="ms-Grid-row">
      <div className="ms-Grid-col ms-sm12">
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row ">
            <div
              className="ms-Grid-col ms-sm12"
              style={{ textAlign: "center" }}
            >
              <img src={svg1} alt="Oando Logo" style={{ width: "200px" }} />
            </div>
          </div>
          <div className="ms-Grid-row">
            {" "}
            <div className="ms-Grid-col ms-sm12" style={{ color: "black" }}>
              <div styel={{ textAlign: "center" }}>
                <span className="ms-fontSize-24 ">We need your SPARS pass</span>
              </div>

              <div>
                <small className="smalltext">
                  Enter your SPARS credentials to login.{" "}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

